import React from "react";
import {useApiQuery} from "../../services/useApiQuery.ts";
import {Access} from "../../services/types.ts";
import AccessKeyPrompt from "../accessKey/AccessKeyPrompt.tsx";
import AdminAccessBlockedMessage from "../accessKey/AdminAccessBlockedMessage.tsx";
import {Card, MessageBar, Spinner} from "@fluentui/react-components";
import {useTranslation} from "react-i18next";
import {resolveAccessState, shouldBlockOnAccessError} from "../../utils/adminAccess.util.ts";

interface SecuredWrapperProps {
    children: React.ReactNode;
    selfServiceButton: React.ReactNode;
}

export const SecuredWrapper: React.FC<SecuredWrapperProps> = (props: SecuredWrapperProps) => {
    const { t } = useTranslation();

    const {
        data: access,
        refetch: recheckAccess,
        isPending: accessLoading,
        error: accessError,
    } = useApiQuery<Access>('/api/access/check', {skipErrorNotification: true});

    const accessState = resolveAccessState(access);
    const accessErrorBanner = accessError && (
        <MessageBar intent="error">{accessError.message}</MessageBar>
    );

    if (accessLoading) {
        return <div>
            <div style={{display: "flex", justifyContent: "flex-end", marginBottom: "12px"}}>
                {props.selfServiceButton}
            </div>
            <Card><Spinner label={t("text.checking-credentials")}/></Card>
        </div>;
    }

    if (shouldBlockOnAccessError(access, accessError)) {
        return <div>
            <div style={{display: "flex", justifyContent: "flex-end", marginBottom: "12px"}}>
                {props.selfServiceButton}
            </div>
            {accessErrorBanner}
        </div>;
    }

    if (accessState === "admin") {
        return <div>{accessErrorBanner}{props.children}</div>;
    }

    if (accessState === "bootstrap_choice") {
        return <div>
            <div style={{display: "flex", justifyContent: "flex-end", marginBottom: "12px"}}>
                {props.selfServiceButton}
            </div>
            {accessErrorBanner}
            <AccessKeyPrompt recheckAccess={recheckAccess} canStartEvaluation={access?.canStartEvaluation}/>
        </div>;
    }

    return <div>
        <div style={{display: "flex", justifyContent: "flex-end", marginBottom: "12px"}}>
            {props.selfServiceButton}
        </div>
        {accessErrorBanner}
        <AdminAccessBlockedMessage accessState={accessState} organizationName={access?.organizationName}/>
    </div>;
};
